import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy
} from '@angular/core';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { BehaviorSubject, Observable } from 'rxjs';
@Component({
  selector: 'date-formated',
  templateUrl: './date-formated.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DateTimeFormatPipe,
    AsyncPipe
]
})
export class DateFormatedComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  keyName!: string ;
  value!:number;
  format!:string;
  

  getDate(date:any):Date{
    return new Date(date);
  }

  isEmptyAndNull(obj: any) {
    if (!obj)
      return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false

  }

  hasValue(obj: any) {
    if (obj != null && obj != undefined)
      return true;
     else return false
  }

}